import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@components/layout/Layout";
import HomePage from "@pages/HomePage";

const PlatformPage = lazy(() => import("@pages/PlatformPage"));
const ServicesPage = lazy(() => import("@pages/ServicesPage"));
const MicrosoftPage = lazy(() => import("@pages/MicrosoftPage"));
const EventsPage = lazy(() => import("@pages/EventsPage"));
const ImpactPage = lazy(() => import("@pages/ImpactPage"));
const InsightsPage = lazy(() => import("@pages/InsightsPage"));
const AboutPage = lazy(() => import("@pages/AboutPage"));
const ContactPage = lazy(() => import("@pages/ContactPage"));
const AcademyPage = lazy(() => import("@pages/AcademyPage"));
const WifiPlatformPage = lazy(() => import("@pages/WifiPlatformPage"));
const ManagedITPage = lazy(() => import("@pages/ManagedITPage"));
const SoftwareDigitalPage = lazy(() => import("@pages/SoftwareDigitalPage"));
const BusinessConsultingPage = lazy(() => import("@pages/BusinessConsultingPage"));
const EventDetailPage = lazy(() => import("@pages/EventDetailPage"));
const ImpactDetailPage = lazy(() => import("@pages/ImpactDetailPage"));
const ArticlePage = lazy(() => import("@pages/ArticlePage"));
const GautengOnTheMovePage = lazy(() => import("@pages/GautengOnTheMovePage"));
const AlexandraWifiIntelligencePage = lazy(() => import("@pages/AlexandraWifiIntelligencePage"));
const ThembisaPlatformParadoxPage = lazy(() => import("@pages/ThembisaPlatformParadoxPage"));
const ThembisaDigitalSkillsGapPage = lazy(() => import("@pages/ThembisaDigitalSkillsGapPage"));
const ThembisaLocalOwnershipPage = lazy(() => import("@pages/ThembisaLocalOwnershipPage"));
const ThembisaDigitalFinancePage = lazy(() => import("@pages/ThembisaDigitalFinancePage"));
const DigitalThembisaCaseStudyPage = lazy(() => import("@pages/DigitalThembisaCaseStudyPage"));
const ThembisaDigitalInfrastructurePage = lazy(() => import("@pages/ThembisaDigitalInfrastructurePage"));
const PrivacyPolicyPage = lazy(() => import("@pages/PrivacyPolicyPage"));

export default function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<div className="min-h-screen bg-konecta-black" />}>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="platform" element={<PlatformPage />} />
            <Route path="services" element={<ServicesPage />} />
            <Route path="microsoft" element={<MicrosoftPage />} />
            <Route path="events" element={<EventsPage />} />
            <Route path="events/:slug" element={<EventDetailPage />} />
            <Route path="impact" element={<ImpactPage />} />
            <Route path="impact/:slug" element={<ImpactDetailPage />} />
            <Route path="insights" element={<InsightsPage />} />
            <Route path="insights/gauteng-on-the-move" element={<GautengOnTheMovePage />} />
            <Route path="insights/alexandra-wifi-intelligence" element={<AlexandraWifiIntelligencePage />} />
            <Route path="insights/thembisa-platform-paradox" element={<ThembisaPlatformParadoxPage />} />
            <Route path="insights/thembisa-digital-skills-gap" element={<ThembisaDigitalSkillsGapPage />} />
            <Route path="insights/thembisa-local-ownership" element={<ThembisaLocalOwnershipPage />} />
            <Route path="insights/thembisa-digital-finance" element={<ThembisaDigitalFinancePage />} />
            <Route path="insights/digital-thembisa-case-study" element={<DigitalThembisaCaseStudyPage />} />
            <Route path="insights/thembisa-digital-infrastructure" element={<ThembisaDigitalInfrastructurePage />} />
            <Route path="insights/:slug" element={<ArticlePage />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="academy" element={<AcademyPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="wifi-platform" element={<WifiPlatformPage />} />
            <Route path="managed-it" element={<ManagedITPage />} />
            <Route path="software-digital" element={<SoftwareDigitalPage />} />
            <Route path="business-consulting" element={<BusinessConsultingPage />} />
            <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
